<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <selectTool ref="selectTool">
      <template slot="btn"><Button @click="getSearchItem" type="primary" class="chaxun">查询</Button><Button
          @click="exportAll" type="error" class="chaxun">导出</Button></template>
    </selectTool>
    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="signInAdd">
        <a @click="seePoint(row.signIn)">{{ row.signInAdd }}</a></template>
      <template slot-scope="{ row, index }" slot="signOutAdd">
        <a @click="seePoint(row.signOut)">{{ row.signOutAdd }}</a>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <ly-map ref="lymap"></ly-map>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "人员姓名",
          key: "personName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "工号",
          key: "jobNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "来源",
          render: (h, data) => {
            return h("div", this.$t("signSource." + data.row.source));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "签到时间",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.signInTime, "yymmddhhmm"));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "签到地点",
          slot: "signInAdd",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "签退时间",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.signOutTime, "yymmddhhmm")
            );
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "签退地点",
          slot: "signOutAdd",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "工作里程/公里",
          key: "mileage",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "工作时长/分",
          key: "duration",
          minWidth: 100,
          maxWidth: 200,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageNumber: 1,
        pageSize: 50,
        source: 4, //来源（0-其他，1-平台，2-客户端，3-车载终端，4-人员工牌）,可用值:0,1,2,3,4
      },

      searchForms: [

        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0,1",
        }, {
          title: "姓名",
          key: "deviceIdList",
          type: "selectPerson",
          isMore:true
        },
      ],
    };
  },
  methods: {
    seePoint(v) {
      this.$refs.lymap.open(v);
    },

    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.work + "/checkin/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].signIn = {
            address: data[i].signInAdd,
            lng: data[i].signInX,
            lat: data[i].signInY,
          };
          data[i].signOut = {
            address: data[i].signOutAdd,
            lng: data[i].signOutX,
            lat: data[i].signOutY,
          };
        }
        console.log(data);
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {

    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      console.log(this.searchItem);
      this.getList();
    },
    exportAll() {
      var params = [
        {
          name: "source",
          value: this.searchItem.source,
        },
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-ep-server-work/checkin/export", params);
    },
    reset() { },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/checkin/person.vue